import styled from 'styled-components';
export const MilestonesWrapper = styled.div`
  margin: 2.5rem auto auto;
  width: 816px;
  max-width: 100%;
  .add-button {
    margin-top: 1.5rem;
  }
`;

export const MileStoneListItem = styled.div`
  padding: 1.75rem;
  box-shadow: 0px 4px 74px rgba(0, 0, 0, 0.04);
  background: ${(props) => props.theme.colors.white};
  margin-top: 1.5rem;
  border-radius: 1.25rem;
  .row-gap {
    gap: 1.5rem;
  }
  .milestone-desc {
    margin-top: 1.5rem;
  }
  .line-height-100-perc {
    line-height: 100%;
  }
  .divider {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
`;
